import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Calendar, User as UserIcon } from 'lucide-react';

/**
 * VanGoghBlogPost - Beautiful magazine-style blog post with Van Gogh aesthetic
 * Completely rebuilt for launch day branding
 */
const VanGoghBlogPost = ({
  title,
  subtitle,
  date,
  author = "Jim Bukowski",
  authorTitle = "Founder & CEO, WestBay Group",
  category,
  heroImage,
  tags = [],
  children
}) => {
  const navigate = useNavigate();

  return (
    <div className="vangogh-blog-wrapper">
      {/* Back to Blog Button */}
      <button className="vangogh-back-btn" onClick={() => navigate('/blog')}>
        <ArrowLeft size={20} />
        <span>Back to Journal</span>
      </button>

      {/* Article Container */}
      <article className="vangogh-article">
        {/* Hero Image Section */}
        {heroImage && (
          <div className="vangogh-hero-image">
            <img src={heroImage} alt={title} />
            <div className="vangogh-hero-overlay"></div>
          </div>
        )}

        {/* Article Header */}
        <header className="vangogh-article-header">
          {category && (
            <div className="vangogh-category">{category}</div>
          )}
          
          <h1 className="vangogh-title">{title}</h1>
          
          {subtitle && (
            <p className="vangogh-subtitle">{subtitle}</p>
          )}

          {/* Meta Info */}
          <div className="vangogh-meta">
            <div className="vangogh-meta-item">
              <Calendar size={16} />
              <span>{date}</span>
            </div>
            <div className="vangogh-meta-divider">•</div>
            <div className="vangogh-meta-item">
              <UserIcon size={16} />
              <span>{author}</span>
            </div>
          </div>
        </header>

        {/* Article Body */}
        <div className="vangogh-content">
          {children}
        </div>

        {/* Tags */}
        {tags.length > 0 && (
          <div className="vangogh-tags">
            {tags.map((tag, idx) => (
              <span key={idx} className="vangogh-tag">{tag}</span>
            ))}
          </div>
        )}

        {/* Author Card */}
        <div className="vangogh-author-card">
          <div className="vangogh-author-avatar">
            <img src="/jim-bukowski-profile.jpg" alt={author} />
          </div>
          <div className="vangogh-author-info">
            <h3 className="vangogh-author-name">{author}</h3>
            <p className="vangogh-author-title">{authorTitle}</p>
            <p className="vangogh-author-bio">
              U.S. Navy Veteran • 30+ Years Cloud Security • AWS Certified • HashiCorp Terraform Certified
            </p>
          </div>
        </div>

        {/* Footer */}
        <footer className="vangogh-footer">
          <div className="vangogh-footer-brand">
            <div className="vangogh-footer-logo">WestBay Group</div>
            <div className="vangogh-footer-tagline">Patent Pending • Poser AI™</div>
          </div>
          <div className="vangogh-footer-badges">
            <span className="vangogh-badge">🦅 Philly Grit</span>
            <span className="vangogh-badge">🎖️ Veteran-Owned</span>
            <span className="vangogh-badge">☁️ Cloud Security</span>
          </div>
        </footer>
      </article>
    </div>
  );
};

export default VanGoghBlogPost;